<div class="root" *cygovLoader="loading" [ngClass]="{'restrict-overflow':showRolePermission}">
  <ng-container
    *ngIf="!isBnb && (!(isBeecher || isMidMarket) || hasEntityIdInRoute) ; else bnbNBeacherTemplate">
    <div class="user-setting-cont">
      <div class="entity-selection-cont">
        <div class="setting-account-title">
          <div cygovSvgIcon [svgName]="'settings-icon'" class="setting-icon"></div>
          <span class="text-title lato-16-n-vw">centraleyes account settings</span>
        </div>
        <div *ngIf="!entityIdInUrl" class="entity-dropdown-cont">
          <cygov-select class="entity-dropdown" [items]="rootEntities" [clearable]="false"
            bindLabel="name" placeholder="Select Entity" [searchable]="true" [customArrow]="true"
            [ngModelValue]="entity?.name" [disabled]="innerLoading"
            (ngModelValueChange)="selectEntityForSettings($event)" [sortByAlphabet]="true"
            [sortByField]="'name'">
          </cygov-select>
        </div>
      </div>
      <div [ngClass]="{'first-section-tabs': true, 'userpermission-mode': !entitySelectionMode }">
        <ng-container
          *ngTemplateOutlet="tabTemplate; context: { tabOptions: upperTabsContentOptions, tabIdentifierLabel: 'upperTab', addScroll: 'true' }">
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

<!-- KMS Modal -->
<!-- ======================================== -->
<!-- Tabs template -->
<!-- ======================================== -->
<ng-template #tabTemplate let-tabOptions="tabOptions" let-identifier='tabIdentifierLabel'
  let-addScroll="addScroll">
  <ul ngbNav #nav="ngbNav" [activeId]="identifier + '#' + tabIdentifer[identifier]"
    (activeIdChange)="changeTabActiveId($event)" [ngClass]="['nav-tabs', identifier]">
    <ng-container *ngFor="let option of tabOptions; let indx=index">

      <li [ngbNavItem]="identifier + '#' + (indx+1)"
        [ngClass]="{'active-nav': tabIdentifer[identifier] == (indx + 1), 'disabled': innerLoading || option.disabled || (!this.entityId && option.label === this.commonEnum.FIRSTPARTY || !this.entityId && option.label === this.commonEnum.THIRDPARTY)}"
        [disabled]="innerLoading || option.disabled" [domId]="identifier + '-'+ indx">
        <a ngbNavLink class="lato-16-n-vw text-capitalize">{{ option.label }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="option.content"></ng-container>
        </ng-template>
      </li>

    </ng-container>
  </ul>
  <div [ngbNavOutlet]="nav" [ngClass]="{'scrollable': addScroll} " class="mt-2"></div>
</ng-template>

<!-- ======================================== -->
<!-- Choose Entity Content -->
<!-- ======================================== -->
<ng-template #generalTab>
  <div *ngIf="entitySelectionMode && !singleEntityLenghtCheck" class="choose-entity-cont">
    <div class="choose-entity-title lato-18-n-vw">
      Choose Entity
    </div>
    <div class="entities-list">
      <div class="entities-box">
        <ng-container *ngFor="let entity of rootEntities;">
          <div class="entity-name-cont" (click)="selectEntityForSettings(entity)">
            <div class="entity-name-text" [attr.title]="entity.name">
              <img [src]="logoUrl" alt="entity-logo" class="entity-logo" *ngIf="logoUrl">
              <span class="text-capitalize" *ngIf="!logoUrl">{{ entity.name }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<!-- ======================================== -->
<!-- Entity Selection & KMS & User Section -->
<!-- ======================================== -->
<ng-template #entityKMSUserPermissionTemp>
  <div [ngClass]="{'spinner': innerLoading }" *ngIf="innerLoading">&nbsp;</div>
  <ng-container *cygovLoader="innerLoading">
    <ng-container *ngIf="entitySelectionMode">
      <div *ngTemplateOutlet="generalTab;"></div>
    </ng-container>

    <ng-container *ngIf="!entitySelectionMode">
      <ng-container *ngIf="isManagerialRole">
        <ng-container *ngTemplateOutlet="KMSTemplate"></ng-container>
      </ng-container>

      <ng-container *ngTemplateOutlet="usersPermissionTemplate;"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<!-- ======================================== -->
<!-- 1st Party Tab Content -->
<!-- ======================================== -->
<ng-template #firstPartyTemp>
  <div class="first-party-container" *ngIf="!entitySelectionMode; else generalTab">

    <!-- ======================================== -->
    <!-- Risk Register -> Dynamic Field -->
    <!-- ======================================== -->
    <div class="risk-register-container" *ngIf="!isBeecher && !isMidMarket">
      <div class="heading-with-icon">
        <div class="section-icon" cygovSvgIcon [svgName]="'risk-register-icon'"></div>
        <div class="title-text lato-18-b-vw txt-clr">Risk Register</div>
      </div>
      <div class="dynamic-field-section">
        <div class="dynamic-field-header">
          <div class="dynamic-field-label lato-16-b-vw">Dynamic Field</div>
          <div class="dynamic-field-edit-toggle"
            [ngClass]="{ 'dynamic-field-edit-toggle--active': riskDynamicFieldEditMode }"
            role="button" tabindex="0" [attr.aria-pressed]="riskDynamicFieldEditMode"
            aria-label="Toggle dynamic field edit mode"
            (click)="toggleRiskDynamicFieldEditMode()"
            (keydown.enter)="toggleRiskDynamicFieldEditMode(); $event.preventDefault()"
            (keydown.space)="toggleRiskDynamicFieldEditMode(); $event.preventDefault()">
            <span class="edit-toggle-icon" cygovSvgIcon [svgName]="'edit-icon'"></span>
          </div>
        </div>
        @if (isRiskDynamicFieldLoading) {
        <div class="dynamic-field-loading">
          <div *cygovLoader="isRiskDynamicFieldLoading"></div>
        </div>
        } @else {
        <div class="dynamic-field-cards">
          <div class="dynamic-field-card"
            [ngClass]="{ 'dynamic-field-card--active': isRiskDynamicFieldPanelOpen && !selectedRiskRegisterDynamicField }"
            role="button" tabindex="0" aria-label="Add a new risk register dynamic field"
            (click)="addRiskRegisterDynamicField()"
            (keydown.enter)="addRiskRegisterDynamicField(); $event.preventDefault()"
            (keydown.space)="addRiskRegisterDynamicField(); $event.preventDefault()">
            <div class="card-title lato-18-n">New Dynamic Field</div>
            <div class="add-field-icon" cygovSvgIcon [svgName]="'add-icon'"></div>
          </div>
          @for (field of riskRegisterDynamicFields; track field.key) {
          <div class="dynamic-field-card"
            [ngClass]="{ 'dynamic-field-card--active': isRiskDynamicFieldPanelOpen && selectedRiskRegisterDynamicField?.key === field.key }"
            role="button" tabindex="0" [attr.aria-label]="'Edit ' + field.label + ' dynamic field'"
            (click)="openRiskRegisterDynamicField(field)"
            (keydown.enter)="openRiskRegisterDynamicField(field); $event.preventDefault()"
            (keydown.space)="openRiskRegisterDynamicField(field); $event.preventDefault()">
            <div class="card-title lato-18-n">{{ field.label }}</div>

            <!-- Delete affordance, edit mode only (Figma node 117:10797). The
                 click must not also open the panel for this card. -->
            @if (riskDynamicFieldEditMode) {
            <div class="card-delete" role="button" tabindex="0"
              [attr.aria-label]="'Delete ' + field.label + ' dynamic field'"
              (click)="confirmDeleteRiskDynamicField(field); $event.stopPropagation()"
              (keydown.enter)="confirmDeleteRiskDynamicField(field); $event.preventDefault(); $event.stopPropagation()"
              (keydown.space)="confirmDeleteRiskDynamicField(field); $event.preventDefault(); $event.stopPropagation()">
              <span aria-hidden="true">&times;</span>
            </div>
            }
          </div>
          }
        </div>

        <!-- Authoring panel — expands in place under the cards. -->
        @if (isRiskDynamicFieldPanelOpen) {
        <cygov-risk-dynamic-field-panel [field]="selectedRiskRegisterDynamicField"
          [isSaving]="isRiskDynamicFieldSaving" [usageCount]="riskDynamicFieldUsageCount" (saved)="saveRiskDynamicField($event)"
          (cancelled)="closeRiskDynamicFieldPanel()" (deleted)="confirmDeleteRiskDynamicField($event)">
        </cygov-risk-dynamic-field-panel>
        }
        }
      </div>

      <!-- Delete confirmation (Figma 141:537) — decides whether values on
           existing risks go with the field. -->
      @if (riskDynamicFieldPendingDelete) {
      <div class="dynamic-field-delete-backdrop">
        <cygov-delete-dynamic-field-modal [field]="riskDynamicFieldPendingDelete"
          [isDeleting]="isRiskDynamicFieldSaving" (confirmed)="deleteRiskDynamicField($event)"
          (cancelled)="closeRiskDynamicFieldDeleteModal()">
        </cygov-delete-dynamic-field-modal>
      </div>
      }
    </div>
    <div class="horiz-seprator" *ngIf="!isBeecher && !isMidMarket"></div>

    <div class="attack-surface-toggle-container" *ngIf="!isMidMarket && !isBeecher && !isBnb">

      <div class="heading-with-icon">
        <img class="external-scan-icon" src="assets/svg/ext-scans.svg" alt="External Scans">
        <div class="lato-18-n-vw title-text">External Scans</div>
      </div>

      <div class="btn-group scans-buttons">
        <div class="tab active-tab lato-14-n-vw"
          [ngClass]="{'active': currentScanType === externalScans.CENTRALEYES }"
          (click)="switchTabs(externalScans.CENTRALEYES)">
          Centraleyes
        </div>
        <div class="tab potential-tab lato-14-n-vw"
          [ngClass]="{'active': currentScanType === externalScans.INTEGRATION }"
          (click)="switchTabs(externalScans.INTEGRATION)">
          Integrations
        </div>
      </div>
      @if (entity?.domainScanEnabledForEntity ||entity?.domainScanned ||
      checkPermissionForExternalDomainScan()) {
      <div class="attack-surface-input-container"
        [ngClass]="{'bitsight-ui': currentScanType === externalScans.INTEGRATION, 'two-domains-added': (domains?.length === 2 && currentScanType === externalScans.CENTRALEYES) , 'two-domains-bitsight': (domains?.length === 2 && currentScanType === externalScans.INTEGRATION) }">
        <div class="inner-div"
          [ngClass]="domains?.length >= 2 ? 'inner-div-dynamic': 'inner-div-width'">
          <ng-container *ngFor="let domain of domains; let idx = index">
            <div class="single-domain-input">
              @if (activeScan && domain?.value !== '' && idx === 0 && domain?.isFromDb) {
              <div class="pencil-icon-wrapper"
                (click)="openAttackSurfaceModal(AttackSurfaceHeader, AttackSurfaceContent, AttackSurfaceFooter)">
                <div class="pencil-icon" cygovSvgIcon [svgName]="'edit-button'"
                  [ngClass]="{'disable-toggle': disableScanning}"></div>
              </div>
              }
              <input class="input-filed lato-18-n-vw" type="text" [ngModel]="domain.value"
                placeholder="Fill Domain" [disabled]="(domain?.value != '' && domain?.isFromDb)"
                (ngModelChange)="updateDomains(idx, $event)" />
              @if(idx > 0) {
              <div class="cancel-domain" (click)="deleteDomains(idx)">
                x
              </div>
              }
            </div>
          </ng-container>
        </div>

        <cygov-add-button [titleName]="'Add Domain'" [textSize]="'14'" [textColor]="'#C5C9D1'"
          (click)="addDomain()" [buttonWidth]="'5.13vw'">
        </cygov-add-button>

        @if (currentScanType === externalScans.INTEGRATION) {
        <div class="vertical-seprator"></div>
        <div
          (click)="openDomainModal(ExternalScansHeader, ExternalScansContent, ExternalScansFooter)">
          <cygov-logo-status-card [logo]="'bitsight-logo.png'" [status]="bitSightStatus"
            [isSVG]="false"></cygov-logo-status-card>
        </div>
        }
      </div>
      <div class="request-to-credit-button activiate-button">
        <button (click)="scanAllDomains()"
          [disabled]="!activeScan || !isValidDomains() || disableScanning || scanInProgess"
          class="lato-18-n-vw">SCAN</button>
      </div>
      }

      <div class="scans-logo">
        <ng-container *ngFor="let item of externalServices">
          <cygov-logo-status-card [logo]="item.logo" [status]="item.status"
            [isSVG]="false"></cygov-logo-status-card>
        </ng-container>
      </div>

      <div class="external-scan-request-btn-container"
        *ngIf="!entity?.domainScanEnabledForEntity && !entity.domainScanned && !checkPermissionForExternalDomainScan()">
        <cygov-button [buttonText]="'EXTERNAL SCAN REQUEST'" [buttonWidth]="'17vw'"
          [buttonHeight]="'4vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0080C3'"
          (click)="openExternalScanRequestModal(externalScanRequestHeader, externalScanRequestContent, externalScanRequestFooter)">
        </cygov-button>
      </div>
    </div>
    <div class="horiz-seprator" *ngIf="!isBeecher && !isMidMarket"></div>
    <div class="threat-intelligence-container" *ngIf="!isBeecher && !isMidMarket">
      <div class="threat-heading">
        <img class="threat-icon" src="assets/svg/external-scans.svg" alt="External Scans">
        <div class="lato-18-n-vw title-text">Threat Intelligence</div>
      </div>
      <div class="threats-logo">
        <ng-container *ngFor="let item of externalFeeds">
          <cygov-logo-status-card [logo]="item.logo" [status]="item.status"
            [isSVG]="false"></cygov-logo-status-card>
        </ng-container>
      </div>
    </div>
    <div class="horiz-seprator" *ngIf="!isMidMarket && !isBeecher && !isBnb"></div>
    @if (
    !isMidMarket && !isBeecher && !isBnb
    ) {
    <cygov-global-controls [currentRootEntity]="this.entity.id"></cygov-global-controls>
    <div class="horiz-seprator"></div>
    }
    <div class="dynamic-label-manager" *ngIf="!isBeecher && !isMidMarket">
      <div class="section-header">
        <div class="icon" cygovSvgIcon [svgName]="'dynamic-label-manager-settings'"></div>
        <h2 class="title lato-18-n-vw">Dynamic Label Manager</h2>
      </div>
      <div class="section-body">
        <div class="section-body-header">
          <div class="section-body-header-left">
            @for (section of dynamicLabelManagerSections; track section) {
            <div class="title-sections lato-16-n-vw"
              (click)="toggleDynamicLabelManagerSection(section.name)" role="button" tabindex="0"
              [attr.aria-label]="'Open ' + section.name + ' dynamic label manager section'"
              (keydown.enter)="toggleDynamicLabelManagerSection(section.name); $event.preventDefault()"
              (keydown.space)="toggleDynamicLabelManagerSection(section.name); $event.preventDefault()">
              <div class="title-sections-inner" [ngClass]="{'selected': section.isSelected}">
                {{
                section.name
                }}
              </div>
            </div>
            }
          </div>
          <div class="section-body-header-right">
            <div class="delete-dynamic-label-btn"
              [ngClass]="{'delete-dynamic-label-btn-disabled': selectedDynamicLabelManagerItems.tags?.length === 0 && selectedDynamicLabelManagerItems.categories?.length === 0 }"
              cygovSvgIcon ngbTooltip="Delete" container="body" [svgName]="'trash-icon-2'"
              role="button"
              [attr.tabindex]="selectedDynamicLabelManagerItems.tags?.length === 0 && selectedDynamicLabelManagerItems.categories?.length === 0 ? -1 : 0"
              [attr.aria-disabled]="selectedDynamicLabelManagerItems.tags?.length === 0 && selectedDynamicLabelManagerItems.categories?.length === 0"
              aria-label="Delete selected dynamic labels"
              (click)="(selectedDynamicLabelManagerItems.tags?.length || selectedDynamicLabelManagerItems.categories?.length) && deleteDynamicLabelManagerItem()"
              (keydown.enter)="(selectedDynamicLabelManagerItems.tags?.length || selectedDynamicLabelManagerItems.categories?.length) && deleteDynamicLabelManagerItem(); $event.preventDefault()"
              (keydown.space)="(selectedDynamicLabelManagerItems.tags?.length || selectedDynamicLabelManagerItems.categories?.length) && deleteDynamicLabelManagerItem(); $event.preventDefault()">
            </div>
            @if (!dynamicLabelManagerEditMode) {
            <div class='edit-users-btn' [ngClass]="'pencil-svg'" cygovSvgIcon
              [svgName]="'edit-icon'" role="button" tabindex="0"
              aria-label="Enable dynamic label manager edit mode"
              (click)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode"
              (keydown.enter)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode; $event.preventDefault()"
              (keydown.space)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode; $event.preventDefault()">
            </div>
            }
            @if (dynamicLabelManagerEditMode){
            <div>
              <cygov-button class="centered-button lato-18-b-vw" [buttonText]="'SAVE'"
                [buttonWidth]="'5vw'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
                [buttonHeight]="'3.4vh'" (click)="updateDynamicLabelManagerItems()">
              </cygov-button>
            </div>
            <div class='edit-users-btn' cygovSvgIcon [svgName]="'x-icon-blue'" role="button"
              tabindex="0" aria-label="Exit dynamic label manager edit mode"
              (click)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode"
              (keydown.enter)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode; $event.preventDefault()"
              (keydown.space)="dynamicLabelManagerEditMode = !dynamicLabelManagerEditMode; $event.preventDefault()">
            </div>
            }
          </div>
        </div>
        <div class="horiz-seprator"></div>
        <div class="section-body-content">
          @if (!isDynamicLabelManagerLoading) {
          <ng-container
            *ngTemplateOutlet="tagCategoryContent; context: { items: filteredDynamicLabelManagerItems.tags, title: filteredDynamicLabelManagerItems.tagsTitle, type: filteredDynamicLabelManagerItems.type, searchObj: 'tagSearchText'}"></ng-container>
          <ng-container
            *ngTemplateOutlet="tagCategoryContent; context: { items: filteredDynamicLabelManagerItems.categories, title: filteredDynamicLabelManagerItems.categoriesTitle, type: filteredDynamicLabelManagerItems.type, searchObj: 'categorySearchText' }"></ng-container>
          <div class="bulk-upload-btn" (click)="openBulkDynamicLabelUploadPopup()" role="button"
            tabindex="0" aria-label="Open bulk dynamic label upload"
            (keydown.enter)="openBulkDynamicLabelUploadPopup(); $event.preventDefault()"
            (keydown.space)="openBulkDynamicLabelUploadPopup(); $event.preventDefault()">
            <span class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
            <div class="bulk-text lato-16-n-vw">Bulk Upload</div>
          </div>
          } @else {
          <div class="loading-container">
            <div *cygovLoader="isDynamicLabelManagerLoading"></div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="horiz-seprator" *ngIf="!isBeecher && !isMidMarket"></div>

    <!-- Score Base -->
    @if (
    !isMidMarket && !isBeecher && !isBnb
    ){
    <cygov-score-base [currentScoringBase]="this.entity?.scoringBase"
      (scoringBaseChange)="updateScoringBase($event)">
    </cygov-score-base>
    <div class="horiz-seprator"></div>
    }

    <div class="frameworks" *ngIf="!isBeecher && !isMidMarket">
      <div class="header">
        <div class="icon" cygovSvgIcon [svgName]="'other-findings'"></div>
        <h2 class="title lato-18-n-vw">Frameworks</h2>
      </div>
      <div class="content">
        <div class="box">
          <!-- Content for the box goes here -->
          <cygov-domain-frameworks-listings class="listings" [title]="''"
            [riskFrameWorkItems]="riskFrameworks" [vendorFrameworkItems]="[]"
            [complianceItems]="standardList" [showFrameworkCounts]="true" [isFirstPartyOn]="false"
            [isThirdPartyOn]="false" [showCheckbox]="true"
            [disableFrameworkChanges]="!checkPermissionForExternalDomainScan()"
            [parentContainerID]="'domain-framework-listing-container-user-settings'">
          </cygov-domain-frameworks-listings>
          <div class="seprator-line"></div>
          <div class="framework-request-btn-container">
            <cygov-button *ngIf="!checkPermissionForExternalDomainScan()"
              class="centered-button lato-18-b-vw" [buttonText]="'FRAMEWORK REQUEST'"
              [buttonWidth]="'12vw'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
              [buttonHeight]="'4vh'" (click)="openNewFrameworkRequestModal()">
            </cygov-button>
            <cygov-button *ngIf="checkPermissionForExternalDomainScan()"
              class="centered-button lato-18-b-vw" [buttonText]="'SAVE'" [buttonWidth]="'12vw'"
              [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'" [buttonHeight]="'4vh'"
              (click)="updateFrameworkSetting()">
            </cygov-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- ======================================== -->
<!-- 3rd Party Tab Content -->
<!-- ======================================== -->
<ng-template #thirdPartyTemp>
</ng-template>

<!-- ======================================== -->
<!-- Users & Permissions Section -->
<!-- ======================================== -->
<ng-template #usersPermissionTemplate>
  <ng-container>
    <div class="show-permission">
      <div [ngClass]="{'kms-allowed': isManagerialRole, 'no-border': isLogoUploaded}"
        class=" root-curtain-open with-kms"
        [ngStyle]="{'border-top':!isMidMarket && !isBeecher && !isBnb?'2px solid #161a2c':'none'}">
        <div class="users-heading">
          <div cygovSvgIcon [svgName]="'user-icon-2'" class="user-icon"></div>
          <div class="users-section-title lato-18-b-vw">
            Users
          </div>
        </div>
        <div class="role-permission-header"
          [ngClass]="{'relative-position': lowerTabsContentOptions[0].relativePos }">
          <ng-container
            *ngTemplateOutlet="tabTemplate; context: { tabOptions: lowerTabsContentOptions, tabIdentifierLabel: 'lowerTab'}">
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

</ng-template>

<!-- ======================================== -->
<!-- KMS section -->
<!-- ======================================== -->
<ng-template #KMSTemplate>
  <div class="kms-cont1" *ngIf="domainSetting?.kmsStatus && !isBeecher && !isMidMarket">
    <div class="kms-title-heading">
      <div cygovSvgIcon [svgName]="'key'" class="key-icon"></div>
      <span class="kms-title-cont lato-18-b-vw">Client Side Key Management</span>
    </div>
    <div class="kms-statistics-cont">
      <div class="kms-statistics-text">
        The Centraleyes platform is end-to-end encrypted by default. Through this setting, admin
        users can manually rotate the key encryption</div>
      <div class="kms-statistics-quotas">
        <div class="active-inactive-btn">
          <span class="inactive-toggle"
            [ngClass]="{'active': !kmsToggle && !activationInProgress}">Inactive</span>
          <span class="active-toggle" [ngClass]="{'active': kmsToggle}"
            (click)="toggleActivation(true)" cygovUserPermission [hiddenMode]="2">Active</span>
        </div>
        <div class="kms-loader">
          <div *cygovLoader="activationInProgress">
          </div>
        </div>
        <div class="inner-statistics">
          <span *ngIf="entity?.KMS?.rotations?.lastRotation" class="last-rotation-cont">Last
            Rotation: <span class="last-rotation-value">
              {{entity.KMS.rotations.lastRotation | date }}</span> </span>
          <span class="annual-allocation-cont">Annual Allocation: <span
              class="annual-allocation-value">{{entity?.KMS?.rotations?.count ?
              entity?.KMS?.rotations?.count : '0'}}/3</span></span>
        </div>
      </div>
      <div class="kms-statistics-rotate-cont">
        <button class="kms-statistics-rotate-btn"
          [ngClass]="{'active': !rotationInProgress && kmsToggle && entity?.KMS?.rotations?.count < 3}"
          (click)="runRotation()" cygovUserPermission [hiddenMode]="1">Rotate</button>
        <div class="kms-loader">
          <div *cygovLoader="rotationInProgress">
          </div>
        </div>
      </div>
      <div class="horiz-seprator"></div>
    </div>
  </div>

  <!-- ======================================== -->
  <!-- Artificial Intelligence -->
  <!-- ======================================== -->
  <div class="ai-settings-container" *ngIf="isAITabAccess">
    <div class="risk-ai-toggle-container">
      <div class="heading-with-icon">
        <img class="robot-icon" src="assets/svg/robot-type2.svg" alt="Robot Icon">
        <div class="lato-18-n-vw title-text">Artificial Intelligence</div>
        <div class="lower-footer-toggle custom-toggle-bg"
          [class]="{'custom-margin-left': true, 'disable-toggle': isAIUpdateInProgress}">
          <cygov-toggle-button [id]="'0'" [isChecked]="aiData?.isActive"
            (changed)="aiData?.isActive ? deActivateRiskAI($event) : openRiskAiConfirmationModal($event) ">
          </cygov-toggle-button>
        </div>
        <div class="credits-container" *ngIf="aiData && aiData?.credits && aiData?.isActive">
          <div class="credits-div lato-16-n-vw">
            (<span>Credits &nbsp;</span> <span>{{aiData.usedCredits}}/</span>
            <span>{{aiData.credits}}</span>)
          </div>
        </div>
        <div class="credits-logs-container" *ngIf="aiData && aiData.isActive && aiData.userName">
          <div class="lato-16-n-vw">{{ aiData.isActive ? 'Activated By:' : 'Deactivated By:' }}
          </div>
          <div class="lato-16-n-vw"> &nbsp; {{aiData.userName}} | </div>
          <div class="lato-16-n-vw">&nbsp; {{aiData.date | date: "MM.dd.yy"}}</div>
        </div>
      </div>
      <div class="sub-heading-with-deatail">
        <div class="title lato-16-b-vw">Centraleyes AI Capabilities</div>
        <div class="text lato-16-n-vw">Enable AI-powered capabilities across the Centraleyes
          platform, including risk generation and mapping, risk insights, policy creation and
          management, questionnaire and assessment auto-answering, remediation analysis, artifact
          and evidence review, and specialized AI agents that assist users with governance, risk,
          and compliance workflows.
          AI capabilities are provided through a controlled, enterprise AI environment and are
          available only within supported platform workflows and to authorized users.</div>
      </div>
      <div class="request-to-credit-button"
        *ngIf="aiData && aiData.credits && ( aiData.usedCredits >= aiData.credits)">
        <cygov-button class="save-btn" [buttonText]="'REQUEST CREDITS'" [buttonWidth]="'8vw'"
          [buttonHeight]="'3.22vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
          (click)="openCreditPackageModal(CreditPackageHeader, CreditPackageContent, CreditPackageFooter)">
        </cygov-button>
      </div>
    </div>
    <div class="horiz-seprator"></div>
  </div>

  <div class="logo-cont">
    <div class="logo-edit-container">
      <div class="heading-with-icon">
        <div class="lato-18-n-vw title-text">Logo</div>
      </div>
      <div class="center-upload-picture">
        <div class="logo">
          <div class="image-container">
            <img class="vendor-logo" *ngIf="logoUrl" [src]="logoUrl" alt="{{ 'logo' }}" />
            <!-- <img class="vendor-logo" *ngIf="uploadedLogo" [src]="uploadedLogo"
            alt="{{ newEntity.name }}" />
            
          <span class="lato-16-n-vw capitalize" *ngIf="!uploadedLogo">{{ newEntity.name
            }}</span> -->
            <div class="upload-logo-text" *ngIf="!logoUrl">
              <div class="text lato-14-n-vw">Add Logo</div>
            </div>
          </div>
        </div>
        <div class="pencil-icon-wrapper">
          <div class="pencil-icon" cygovSvgIcon [svgName]="'edit-button'"
            (click)="uploadLogo.click()">
            <input #uploadLogo class="file-input" type="file" name="logo"
              accept=".gif, .jpg, .jpeg, .bmp, .tif, .png" (change)="imgHandler($event)" />
          </div>
        </div>
      </div>
    </div>
    <div class="horiz-seprator"></div>
  </div>
</ng-template>

<!-- ======================================== -->
<!-- Users section -->
<!-- ======================================== -->
<ng-template #usersTemp>
  <div class="users-table-filters">
    <div class="curtain-header" [class.curtain-header-compact]="isBeecher || isMidMarket">
      <div class="header-left-menu">
        <ng-container *ngTemplateOutlet="filters"></ng-container>
        <div (click)="addNewUser()" class="lato-16-n-vw add-button add-user-btn" cygovUserPermission
          role="button" tabindex="0" aria-label="Add new user"
          (keydown.enter)="addNewUser(); $event.preventDefault()"
          (keydown.space)="addNewUser(); $event.preventDefault()">
          <span class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
          <span class="button-text">Add New User</span>
        </div>
      </div>

      <div class="header-right-menu">

        <div style="padding-right: 1vw;" *ngIf="isEditMode && !isBeecher && !isMidMarket">
          <cygov-button class="save-btn" [buttonText]="'REGULATORY WATCH ADMIN'"
            [buttonWidth]="'12vw'" [buttonHeight]="'3.22vh'" [buttonColor]="'#29A9EB'"
            [hoverColor]="'#0B76B9'" [disableClick]="!isMsspSelected()"
            [fullyDisabled]="!isMsspSelected()" (click)="onRegulatoryWatchAdmin()">
          </cygov-button>
        </div>
        <div class="actions-container action-icon-tooltip" *ngIf="!isEditMode" cygovUserPermission>
          <div class="action-icon" [ngClass]="{
        'disabled': !isUserSelected()
      }" cygovSvgIcon (click)="deleteUserPopup()" ngbTooltip="Delete" container="body"
            [svgName]="'trash-icon'" role="button" [attr.tabindex]="isUserSelected() ? 0 : -1"
            [attr.aria-disabled]="!isUserSelected()" aria-label="Delete selected users"
            (keydown.enter)="deleteUserPopup(); $event.preventDefault()"
            (keydown.space)="deleteUserPopup(); $event.preventDefault()"></div>
          <!-- Commenting out till the feature is implemented -->
          <!-- <div class="action-icon" cygovSvgIcon (click)="onResetPhone()"
        ngbTooltip="Reset Phone" container="body" [svgName]="'phone'"></div> -->
          <div class="action-icon" [ngClass]="{'disabled': !isUserSelected()}" cygovSvgIcon
            (click)="resendEnrollmentPopup()" ngbTooltip="Reset User" container="body"
            [svgName]="'user'" role="button" [attr.tabindex]="isUserSelected() ? 0 : -1"
            [attr.aria-disabled]="!isUserSelected()" aria-label="Reset selected users"
            (keydown.enter)="resendEnrollmentPopup(); $event.preventDefault()"
            (keydown.space)="resendEnrollmentPopup(); $event.preventDefault()"></div>
        </div>
        <div class="edit-mode-buttons" cygovUserPermission>
          <cygov-button *ngIf="isEditMode" class="save-btn" [buttonText]="'SAVE'"
            [buttonWidth]="'5.2vw'" [buttonHeight]="'3.22vh'" [buttonColor]="'#29A9EB'"
            [hoverColor]="'#0B76B9'" (click)="saveUpdatedUsers()">
          </cygov-button>
          <div class='edit-users-btn' [ngClass]="isEditMode ? 'cross-svg':'pencil-svg'" cygovSvgIcon
            [svgName]="isEditMode ? 'x-icon-blue':'edit-icon'" role="button" tabindex="0"
            [attr.aria-label]="isEditMode ? 'Exit user edit mode' : 'Enable user edit mode'"
            (click)="handleEditMode()" (keydown.enter)="handleEditMode(); $event.preventDefault()"
            (keydown.space)="handleEditMode(); $event.preventDefault()"></div>
        </div>
      </div>
    </div>
    <cygov-user-list (onSort)="sortData($event)" (userSelected)="onUserSelected($event)"
      class="cygov-user-list" [rolesList]="allRoles" [childEntities]="childEntities"
      [userList]="filteredUserList" [vendorHashEntities]="vendorHash" [rootEntity]="entity">
    </cygov-user-list>
  </div>
</ng-template>

<!-- ======================================== -->
<!-- Role Permission Section -->
<!-- ======================================== -->
<ng-template #rolePermissionTemp>
  <div class="user-permission-section" *ngIf="isCurrentUserAccessRoleSection()">
    <div class="permission-content">
      <div class="role-box">
        <div class="new-role" (click)="displayRolePermission()" cygovUserPermission>
          <span class="box">
            New Role Group
          </span>
          <span class="new-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
        </div>
        <ng-container *ngFor="let role of defaultRoles; let i = index">
          <span class="capitalize default-role"
            [ngClass]="{'selected': selectedRole?.id === role.id}"
            (click)="selectRole($event, i, UsersSettingConstant.default)"
            *ngIf="!((role.name === 'mssp' || role.name === 'admin') && isCurrentUserAdmin)">
            {{ role.name }}
          </span>
        </ng-container>
        <span container="body" *ngFor="let role of customRoles; let i = index"
          [ngClass]="{'selected':selectedRole?.id===role.id}" class="capitalize custom-role"
          (mouseenter)="checkIfEllipsis($event.target)" [ngbTooltip]="role.name"
          [disableTooltip]="!showColumnTooltip" (click)="selectRole($event, i)">{{role.name}}
        </span>
      </div>
    </div>
    <div class="underline"></div>
  </div>
  <div class="role-permission-popup-cont"
    *ngIf="showRolePermission && isCurrentUserAccessRoleSection()">
    <cygov-role-permission (closeModal)="showRolePermission=false" [editMode]="roleSelected"
      [disableScreen]="isDefaultRole || currentUser?.isViewOnly" [entityId]="entityId"
      [entityList]="entityList" [selectedRole]="selectedRole" [vendorsList]="vendorsList"
      (onDelete)="deleteCustomRole($event)" [isGlobalUserSetting]="isGlobalUserSetting">
    </cygov-role-permission>
  </div>
</ng-template>

<!-- BnB / Beechers user setting -->
<ng-template #bnbNBeacherTemplate>
  <div class="curtain" #curtain></div>
  <div class="root-top" *ngIf="!showRolePermission">
    <div class="lato-18-n-vw uppercase">
      User Settings
    </div>
  </div>
  <ng-container *ngIf="!showRolePermission">
    <div class="show-permission">
      <div class="root-curtain-open">
        <div class="role-permission-header without-kms">
          <div class="users-permission-wrapper">
            <div class="users-tab"
              (click)="changePermissionHeaderToPermissions(UsersSettingScreens.users)">
              <div class="lato-18-b-vw capitalize align-text"
                [ngClass]="{'users-text': isUsersScreen}">
                {{ filteredUserList.length }} Users
              </div>
            </div>
            <div class="permissions-tab"
              (click)="changePermissionHeaderToPermissions(UsersSettingScreens.permissions)">
              <div class="lato-18-b-vw capitalize align-text"
                [ngClass]="{'permissions-text': !isUsersScreen}">
                Role Permissions
              </div>
            </div>
          </div>
          <div class="search-and-add-new-wrapper" *ngIf="isUsersScreen">
            <!-- Commenting out code because search is required for all domains -->
            <!-- <div class="search-wrapper" *ngIf="!isBnb">
              <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
              <input type="text" class="form-control search" aria-label="Search"
                placeholder="Search" name="search" [(ngModel)]="searchText"
                (input)="filterChanged('search', searchText)" spellcheck="true" />
            </div> -->
            <div (click)="addNewUser()" class="lato-16-n-vw add-button" cygovUserPermission>
              <span class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
              <span class="button-text">Add New User</span>
            </div>
          </div>
        </div>
        <div class="role-permission-header-underline"></div>
        <div class="curtain-header" [class.curtain-header-compact]="isBeecher || isMidMarket"
          *ngIf="isUsersScreen">
          <div class="header-left-menu">
            <ng-container *ngTemplateOutlet="filters"></ng-container>
          </div>

          <div class="header-right-menu">
            <div class="actions-container action-icon-tooltip" *ngIf="!isEditMode"
              cygovUserPermission>
              <div class="action-icon" [ngClass]="{
              'disabled': !isUserSelected()
            }" cygovSvgIcon (click)="deleteUserPopup()" ngbTooltip="Delete" container="body"
                [svgName]="'trash-icon'"></div>
              <!-- Commenting out till the feature is implemented -->
              <!-- <div class="action-icon" cygovSvgIcon (click)="onResetPhone()"
              ngbTooltip="Reset Phone" container="body" [svgName]="'phone'"></div> -->
              <div class="action-icon" [ngClass]="{'disabled': !isUserSelected()}" cygovSvgIcon
                (click)="resendEnrollmentPopup()" ngbTooltip="Reset User" container="body"
                [svgName]="'user'"></div>
            </div>
            <div class="edit-mode-buttons" cygovUserPermission>
              <cygov-button *ngIf="!isBeecher && !isMidMarket" class="save-btn"
                [buttonText]="'REGULATORY WATCH ADMIN'" [buttonWidth]="'12vw'"
                [buttonHeight]="'3.22vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
                [disableClick]="!isMsspSelected()" [fullyDisabled]="!isMsspSelected()"
                (click)="onRegulatoryWatchAdmin()">
              </cygov-button>
              <cygov-button *ngIf="isEditMode" class="save-btn" [buttonText]="'SAVE'"
                [buttonWidth]="'5.2vw'" [buttonHeight]="'3.22vh'" [buttonColor]="'#29A9EB'"
                [hoverColor]="'#0B76B9'" (click)="saveUpdatedUsers()">
              </cygov-button>
              <div class='edit-users-btn' [ngClass]="isEditMode ? 'cross-svg':'pencil-svg'"
                cygovSvgIcon [svgName]="isEditMode ? 'x-icon-blue':'edit-icon'"
                (click)="handleEditMode()"></div>
            </div>
          </div>
        </div>
        <cygov-user-list (onSort)="sortData($event)" *ngIf="isUsersScreen"
          (userSelected)="onUserSelected($event)" class="cygov-user-list" [rolesList]="allRoles"
          [childEntities]="childEntities" [userList]="filteredUserList"
          [vendorHashEntities]="vendorHash" [rootEntity]="entity">
        </cygov-user-list>

        <!-- Role Permission Section -->
        <!-- For Now disabling this feature so that the back-end gets completed -->
        <div class="user-permission-section"
          *ngIf="isCurrentUserAccessRoleSection() && !isUsersScreen">
          <div class="permission-content">
            <div class="role-box">
              <div class="new-role" (click)="displayRolePermission()" cygovUserPermission>
                <span class="box">
                  New Role Group
                </span>
                <span class="new-icon" cygovSvgIcon [svgName]="'add-icon'"></span>
              </div>
              <span *ngFor="let role of defaultRoles; let i = index" class="capitalize default-role"
                [ngClass]="{'selected':selectedRole?.id===role.id}"
                (click)="selectRole($event, i ,UsersSettingConstant.default)">{{role.name}}</span>
              <span container="body" *ngFor="let role of customRoles; let i = index"
                [ngClass]="{'selected':selectedRole?.id===role.id}" class="capitalize custom-role"
                (mouseenter)="checkIfEllipsis($event.target)" [ngbTooltip]="role.name"
                [disableTooltip]="!showColumnTooltip" (click)="selectRole($event, i)">{{role.name}}
              </span>
            </div>
          </div>
          <div class="underline"></div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="showRolePermission && isCurrentUserAccessRoleSection() && !isUsersScreen">
    <cygov-role-permission (closeModal)="showRolePermission=false" [editMode]="roleSelected"
      [disableScreen]="isDefaultRole || currentUser?.isViewOnly" [entityId]="entityId"
      [entityList]="entityList" [selectedRole]="selectedRole" [vendorsList]="vendorsList"
      (onDelete)="deleteCustomRole($event)">
    </cygov-role-permission>
  </ng-container>
</ng-template>

<ng-template #filters>
  <span class="lato-16-n-vw role-filter align-text">Filter by Role</span>
  <cygov-select class="with-margin-right filter-drop-down"
    [items]="roleFilterOptions | filterRemoveValue:{id:roleFilter.id}:'id'" [clearable]="false"
    [(ngModelValue)]="roleFilter" bindLabel="name"
    (ngModelValueChange)="filterChanged('role', roleFilter.id)" placeholder="User Role"
    [searchable]="true" [customArrow]="true">
  </cygov-select>
  <span class="lato-16-n-vw with-margin-left align-text">Filter by Status</span>
  <cygov-select class="filter-drop-down" [sortByAlphabet]="true"
    [items]="statusFilterOptions | filterRemoveValue:{id:statusFilter.id}:'id'" [clearable]="false"
    [(ngModelValue)]="statusFilter" bindLabel="name" [searchable]="true" [customArrow]="true"
    (ngModelValueChange)="filterChanged('status', statusFilter.id)" placeholder="Status">
  </cygov-select>
  <div class="search-wrapper">
    <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
    <input type="text" class="form-control search" aria-label="Search" placeholder="Search"
      name="search" [(ngModel)]="searchText" (keyup)="filterChanged('search', searchText)"
      spellcheck="true" />
  </div>
</ng-template>

<ng-template #CreditPackageHeader>
  <!-- Empty for filters -->
  <div class="robot-icon-cont" cygovSvgIcon [svgName]="'robots-type1'" aria-label="Robot Icon">
  </div>
</ng-template>

<ng-template #CreditPackageContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <span class='lato-20-n-vw'>Please note, that you do not have AI credits available.
    </span>
    <span class='lato-20-n-vw'>To add more please contact <span
        class="txt-blue">sales&#64;centraleyes.com</span>.
    </span>
  </div>
</ng-template>

<ng-template #CreditPackageFooter>
  <div class='confirm-filter-popup-footer d-flex justify-content-center'>
    <cygov-button class='standard-btn lato-14-n-vw' [buttonText]="'Ok'" [buttonWidth]="'5vw'"
      [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'" (click)="closeModal()">
    </cygov-button>
  </div>
</ng-template>


<ng-template #AttackSurfaceHeader>
  <!-- Empty for filters -->
  <span class="lato-24-n-vw text-white">Attack Surface</span>
</ng-template>

<ng-template #AttackSurfaceContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <span class='lato-22-n-vw'>Please note, you are about to replace the current domain:
    </span>
    <span class='lato-22-n-vw'> <span
        class="txt-blue">{{domainValue?domainValue:'http://caliberbankflorida.com/'}}</span>
      &nbsp;
      <span class='lato-22-n-vw'>with:</span>
    </span>
    <div class="attack-surface-input-container">
      <input type="text" class="input-filed" [(ngModel)]="updatedDomainValue">
    </div>
  </div>
</ng-template>

<ng-template #AttackSurfaceFooter>
  <div class='atack-surface-footer d-flex justify-content-center'>
    <cygov-button class='standard-btn lato-14-n-vw' [buttonText]="'CONFIRM'" [buttonWidth]="'5vw'"
      [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      (click)="domainEdit(true)">
    </cygov-button>
    <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
      [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
      (click)="domainEdit(false)">
    </cygov-button>
  </div>
</ng-template>

<ng-template #externalScanRequestHeader>
  <!-- Empty for filters -->
  <span class="lato-20-n-vw text-white">REQUEST EXTERNAL SCAN</span>
</ng-template>

<ng-template #externalScanRequestContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <span class='lato-20-n-vw'>I would like to activate the external scan feature.
    </span>

  </div>
</ng-template>

<ng-template #externalScanRequestFooter>
  <div class='external-scan-request-footer d-flex justify-content-center'>
    <cygov-button class='lato-18-n-vw' [buttonText]="'SEND'" [buttonWidth]="'5.15vw'"
      [textSize]="'18'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      (click)="openExternalScanRequestScanAcknowledgementModal(externalScanRequestScanAcknowledgementHeader, externalScanRequestScanAcknowledgementContent, externalScanRequestScanAcknowledgementFooter)">
    </cygov-button>
    <cygov-button class="button-margin lato-18-n-vw" [buttonText]="'CANCEL'"
      [buttonColor]="'#030715'" [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5.15vw'"
      [textSize]="'18'" [textColor]="'#C5C9D1'" (click)="closeModal()">
    </cygov-button>
  </div>
</ng-template>

<ng-template #externalScanRequestScanAcknowledgementHeader>
  <!-- Empty for filters -->
</ng-template>

<ng-template #externalScanRequestScanAcknowledgementContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <div class="tick-icon-container">
      <div class="tick-icon" cygovSvgIcon [svgName]="'complete-popup'"></div>
    </div>
    <span class='lato-22-n-vw'>Your request has been received.
    </span>
    <span class='lato-22-n-vw'>A Centraleyes team member will
      contact you shortly.</span>
  </div>
</ng-template>

<ng-template #externalScanRequestScanAcknowledgementFooter>
  <div class='external-scan-request-acknowledgement-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'OK'" [buttonWidth]="'6.6vw'"
      [buttonHeight]="'4.2vh'" [textSize]="'18'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      (click)="closeModal()">
    </cygov-button>

  </div>
</ng-template>



<ng-template #ExternalScansHeader>
  <!-- Empty for filters -->
  <span class="lato-18-n-vw text-white">BITSIGHT ACCOUNT INFORMATION</span>
</ng-template>

<ng-template #ExternalScansContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <div class="ext-scans-input-container">
      <label class="lato-18-n-vw text-white pb-label">Url</label>
      <input type="text" class="input-filed" [(ngModel)]="bitsightUrl" readonly>
    </div>
    <div class="ext-scans-input-container pt-4">
      <label class="lato-18-n-vw text-white pb-label">API Key</label>
      <input type="text" class="input-filed" [(ngModel)]="bitsightToken">
    </div>
  </div>
</ng-template>

<ng-template #ExternalScansFooter>
  <div class='atack-surface-footer d-flex justify-content-center bitsight-connect-btn'>
    <cygov-button class='standard-btn lato-14-n-vw' [buttonText]="'SAVE & CONNECT'"
      [buttonWidth]="'5vw'" [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      (click)="connectBitsight()" [disableClick]="!bitsightToken || bitsightToken === ''">
    </cygov-button>
    <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
      [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
      (click)="closeModal()">
    </cygov-button>
  </div>
</ng-template>

<ng-template #tagCategoryContent let-items="items" let-title="title" let-type="type"
  let-searchObj="searchObj">
  <div class="dynamic-label-manager-container">
    <div class="dynamic-label-manager-container-header">
      <div class="title lato-18-n-vw">{{ title }}</div>
      <span class="add-tag-icon" cygovSvgIcon [svgName]="'add-icon'"
        (click)="showAddBoxForTagOrCategory(title)"></span>
    </div>
    <div class="dynamic-label-manager-container-search-bar">
      <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'"></div>
      <input type="text" class="form-control search" aria-label="Search" placeholder="Search"
        name="search" [(ngModel)]="searchFormObject[searchObj]"
        (keyup)="searchDynamicLabelManagerItems(searchFormObject[searchObj], title, type)"
        spellcheck="true" />
    </div>
    @if(title !== 'Policy Categories') {
    <div class="dynamic-label-manager-container-content">
      @if (isAddEnabled && currentSelectedSection === title) {
      <div class="custom-add-box">
        <input type="text" name="newTag" class="custom-add-input" autofocus
          [(ngModel)]="newTagValue" />
        <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
          <span>×</span>
        </div>
        <button class="add-btn lato-12-n-vw"
          (click)="addNewTagOrCategory(title, null, type)">Add</button>
      </div>
      }
      @if (items?.length) {
      <div class="dynamic-label-manager-container-content-item">
        <input id="item-all-{{ title }}" name="item-all-{{ title }}" type="checkbox"
          [checked]="isAllDynamicLabelsSelected(items, title)"
          (change)="toggleAllDynamicLabelManagerItems(items, title)" />
        <label for="item-all-{{ title }}" class="lato-16-n-vw label">All</label>
      </div>
      }
      @for (item of items; track item; let i = $index) {
      <div class="dynamic-label-manager-container-content-item">
        <input id="item{{ item.id }}" name="item{{ item.id }}" type="checkbox"
          [checked]="item.selected" (change)="selectDynamicLabelManagerItem(item, title)" />
        @if(!dynamicLabelManagerEditMode){
        <label for="item{{ item.id }}" class="lato-16-n-vw label">
          {{ item.name }}
        </label>
        } @else {
        <input type="text" name="newTag" class="custom-add-input" autofocus
          [(ngModel)]="item.name" />
        }
      </div>
      }
    </div>
    }
    @else {
    <div class="dynamic-label-manager-container-content">
      <!-- Top-level category add box (rendered before the list) -->
      @if (isAddEnabled && currentSelectedSection === title) {
      <div class="dynamic-label-manager-container-content-header">
        <div class="custom-add-box">
          <input type="text" name="newTag" class="custom-add-input" autofocus
            [(ngModel)]="newTagValue" />
          <span class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">×</span>
          <button class="add-btn lato-12-n-vw"
            (click)="addNewTagOrCategory(title, null, type)">Add</button>
        </div>
      </div>
      <div class="horiz-seprator"></div>
      }
      @if (items?.length) {
      <div class="dynamic-label-manager-container-content-item">
        <input id="item-all-{{ title }}" name="item-all-{{ title }}" type="checkbox"
          [checked]="isAllDynamicLabelsSelected(items, title)"
          (change)="toggleAllDynamicLabelManagerItems(items, title)" />
        <label for="item-all-{{ title }}" class="lato-16-n-vw label">All</label>
      </div>
      <div class="horiz-seprator"></div>
      }
      @for (item of items; track item; let i = $index) {
      <div class="dynamic-label-manager-container-content-header">
        @if(!dynamicLabelManagerEditMode || item.isDefault){
        <div class class="lato-16-n-vw title" [style.color]="item.color">{{
          item.name }}</div>
        <span class="add-tag-icon" cygovSvgIcon [svgName]="'add-icon'"
          (click)="showAddBoxForTagOrCategory(title, item.name)"></span>
        } @else {
        <input type="text" name="newTag" class="custom-add-input" autofocus
          [(ngModel)]="item.name" />
        }
      </div>
      <div class="horiz-seprator"></div>
      <!-- Sub-value add box (rendered before the sub-values list) -->
      @if (isAddEnabled && currentSelectedSection === item.name) {
      <div class="custom-add-box">
        <input type="text" name="newTag" class="custom-add-input" autofocus
          [(ngModel)]="newTagValue" />
        <div class="custom-add-close" (click)="closeAddBoxForTagOrCategory(title)">
          <span>×</span>
        </div>
        <button class="add-btn lato-12-n-vw"
          (click)="addNewTagOrCategory(title, item.name, type)">Add</button>
      </div>
      }
      @for (subValue of item.values; track subValue; let j = $index) {
      <div class="dynamic-label-manager-container-content-item">
        <input id="item{{ subValue.id }}" name="item{{ subValue.id }}" type="checkbox"
          [checked]="subValue.selected" (change)="selectDynamicLabelManagerItem(subValue, title)" />
        @if(!dynamicLabelManagerEditMode){
        <label for="item{{ subValue.id }}" class="lato-16-n-vw label">
          {{ subValue.name }}
        </label>
        } @else {
        <input type="text" name="newTag" class="custom-add-input" autofocus
          [(ngModel)]="subValue.name" />
        }
      </div>
      }
      }
    </div>
    }
  </div>
</ng-template>